export const state = () => ({
  quiz: null,
  focusKey: null,
})

export const mutations = {
  setQuiz(state, quiz) {
    state.quiz = quiz;
  },
  setQuestions(state, questions) {
    state.quiz = {
      ...state.quiz,
      questions
    }
  },
  setQuestionByFocusKey(state, question) {
    const questions = [...state.quiz.questions].map((q, key) => {
      if (key === state.focusKey) {
        return question;
      }

      return q;
    });

    state.quiz = {
      ...state.quiz,
      questions
    }
  },
  setFocusKey(state, focusKey) {
    state.focusKey = focusKey;
  }
}

export const actions = {

}
